var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("MySpace")]),_c('div',[_vm._v("昵称："+_vm._s(_vm.nickname))]),_c('div',[_vm._v("头像URL："+_vm._s(_vm.imageUrl))]),_c('button',{on:{"click":_vm.doLogout}},[_vm._v("退出登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }